var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"volumeChart"}},[_c('echarts',{ref:"volumeChart",attrs:{"options":_vm.options(),"autoresize":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }